<template>
    <el-dialog title="选择书籍多选" :visible.sync="innerVisible" class="dialog-table" width="800px" :before-close="closeDialogTable">
        <el-form :inline="true" :model="formInlineMore" ref="formInlineMore" size="small" class="demo-form-inline">
            <el-form-item label="书籍名称" prop="bookName">
                <el-input v-model="formInlineMore.bookName" placeholder="请输入书籍名称" clearable @keyup.enter.native="search" @clear="search" style="width: 220px;"></el-input>
            </el-form-item>
            <el-form-item label="书籍ID" prop="bookId">
                <el-input type="number" v-model="formInlineMore.bookId" placeholder="请输入书籍ID" clearable @keyup.enter.native="search" @clear="search" style="width: 220px;"></el-input>
            </el-form-item>
            <el-form-item label="一级分类" prop="firstCategoryId" style="margin-right: 30px;">
                <el-select v-model="formInlineMore.firstCategoryId" placeholder="请选择一级分类" clearable @change="firstClick" style="width: 150px;">
                    <el-option v-for="item in firstCateOptions" :key="item.firstCategoryId" :label="item.firstCategoryName" :value="item.firstCategoryId"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="二级分类" prop="secondCategoryId" style="margin-right: 30px;">
                <el-select v-model="formInlineMore.secondCategoryId" placeholder="请选择二级分类" clearable @change="search" style="width: 150px;">
                    <el-option v-for="item in secondCateOptions" :key="item.secondCategoryId" :label="item.secondCategoryName" :value="item.secondCategoryId"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="tableTh">
            <el-table :data="tableData.result" border ref="multipleTable" @selection-change="handleSelectionChange" @row-click="handleRowClick" height="345" row-key="id" style="width: 100%" class="tableStyle">
                <el-table-column type="selection" width="60" align="center">
                </el-table-column>
                <el-table-column label="封面" width="100">
                    <template slot-scope="scope">
                        <img class="cover-td" :src="scope.row.coverName" height="50"/>
                    </template>
                </el-table-column>
                <el-table-column label="书名">
                    <template slot-scope="scope">
                        <span>{{scope.row.bookName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="书籍ID">
                    <template slot-scope="scope">
                        <span>{{scope.row.bookId}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="statusOnline" label="状态" width="80">
                    <template slot-scope="scope">
                        <span v-if="scope.row.rackStatus == 0" class="danger-text">已下架</span>
                        <span v-if="scope.row.rackStatus == 1" class="succes-text">上架中</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="foot-table" style="text-align:center;">
                <el-pagination
                        @current-change="handleCurrentChange"
                        @size-change="handleSizeChange"
                        :page-sizes="[5, 20, 50, 100, 200, 500]"
                        :page-size="pageSize"
                        background
                        :current-page="currentPage"
                        layout="sizes, prev, pager, next, jumper, ->, total"
                        :total="tableData.totalNum">
                </el-pagination>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialogTable">取 消</el-button>
            <el-button type="primary" @click="tableSureBtn">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { bookListDistribution, firstcate, secondcate } from "@/api/dydp/media/manage";
var bookList = []
var bookListStr = ''
export default {
    name: 'BookTableMore',
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        appId: String,
    },
    data() {
        return {
            innerVisible: this.visible,
            selected: [],
            formInlineMore: {
                bookId: '',
                bookName: '',
                firstCategoryId: '',
                secondCategoryId: ''
            },
            firstCateOptions: [],
            secondCateOptions: [],
            tableData: {
                pageSize: 20,
                pageNo: 1,
                totalPage: 1,
                totalNum: 0,
                result: []
            },
            currentPage: 1,
            pageSize: 5,
            currentRow: ''
        }
    },
    watch: {
        visible(newValue) {
            this.innerVisible = newValue;
            // 弹框显示赋值默认值
            this.$nextTick(()=>{
                this.$refs.multipleTable.clearSelection();
            })
            this.formInlineMore = {
                bookId: '',
                bookName: '',
                firstCategoryId: '',
                secondCategoryId: ''
            }
            this.getTableBook()
        },
        appId(newValue) {
            this.appId = newValue
            this.getTableBook()
        },
        innerVisible(newValue) {
            this.$emit('update:visible', newValue);
        },
    },
    mounted() {
        this.getTableBook()
        this.getFirstCate()
    },
    methods: {
        search () {
            this.currentPage = 1
            this.getTableBook()
        },
        resetQuery() {
            this.$refs['formInline'].resetFields()
            this.getTableBook()
        },
        handleRowClick(row) {
            this.$refs.multipleTable.toggleRowSelection(row);
        },
        // 多选
        handleSelectionChange(val) {
            bookList = []
            val.forEach((item) => {
                bookList.push(item.bookId)
            })
            bookListStr = bookList.toString()
            this.currentRow = val
        },
        // 分页
        handleCurrentChange (value) {
            this.currentPage = value
            this.getTableBook()
        },
        // pageSize切换
        handleSizeChange (val) {
            this.pageSize = val
            this.currentPage = 1
            this.getTableBook()
        },
        // 确定按钮
        tableSureBtn() {
            if(bookListStr){
                this.$emit('bookSure', {
                    currentRow: this.currentRow,
                    bookListStr: bookListStr,
                });
                this.$emit('cancelDialogBook', false);
            } else {
                this.$message.error('请选择短篇')
            }

            // this.$emit('videoSure', this.currentRow);
            // this.$emit('cancelDialogVideo', false);
            // this.$refs.singleTable.setCurrentRow();
        },
        // 关闭弹框
        closeDialogTable () {
            console.log(22)
            this.$emit('cancelDialogBook', false);
        },
        getTableBook() {
            let paramJson = {
                distributionStatus: 0,
                rackStatus: 1,
                pageNo: this.currentPage,
                pageSize: this.pageSize,
                bookId: this.formInlineMore.bookId.trim(),
                bookName: this.formInlineMore.bookName.trim(),
                firstCategoryId: this.formInlineMore.firstCategoryId,
                secondCategoryId: this.formInlineMore.secondCategoryId
            };
            // let json1 = this.formInline;
            // let paramJson = { ...json1, ...json2 };
            bookListDistribution(paramJson).then(response => {
                if (response.data.head.flag === 0) {
                    this.tableData = response.data.content
                } else {
                    this.$message.error(response.data.head.desc)
                }
            });
        },
        firstClick(val) {
            this.getSecondCate(val)
            this.search()
        },
        getFirstCate() {
            firstcate({}).then(response => {
                if (response.data.head.flag === 0) {
                this.firstCateOptions = response.data.content
            } else {
                this.$message.error(response.data.head.desc)
            }
        });
        },
        getSecondCate(id) {
            secondcate({
                firstCategoryId: id
            }).then(response => {
                if (response.data.head.flag === 0) {
                this.secondCateOptions = response.data.content
            } else {
                this.$message.error(response.data.head.desc)
            }
        });
        },
    }
}
</script>
